import loadWishListModule from './modules/WishList.module';
const loadWishlistMenuItemModule = () => ({
    hasRouter: false,
    modules: [loadWishListModule()],
});
export default loadWishlistMenuItemModule;
